import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * PasswordInput — password <input> with a show/hide toggle button.
 * Pass through all native input props. `testid` sets both the input's
 * data-testid and the toggle button's (<testid>-toggle).
 */
export default function PasswordInput({ testid, className = "", ...rest }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        {...rest}
        data-testid={testid}
        type={show ? "text" : "password"}
        className={`${className} pr-10`}
      />
      <button
        type="button"
        tabIndex={-1}
        data-testid={testid ? `${testid}-toggle` : undefined}
        onClick={() => setShow((v) => !v)}
        className="absolute inset-y-0 right-2 flex items-center justify-center w-7 text-slate-400 hover:text-slate-900 transition-colors"
        aria-label={show ? "Hide password" : "Show password"}
      >
        {show ? <EyeOff className="w-4 h-4" strokeWidth={1.75} /> : <Eye className="w-4 h-4" strokeWidth={1.75} />}
      </button>
    </div>
  );
}
